'use client';

import React, { useEffect, useRef } from 'react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ribbonList } from '@/constants/list';
import { getImageUrl } from '@/utils/string';
import { imageTypes } from '@/constants/types';
import Badge from '../Badge';
import WishListButton from '../Button/WishListButton';
import ImageComponentV2 from '../Image/ImageComponentV2';

// swiper slider
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function ProductDetailsSliderV2({
  onClick = () => {},
  currentProduct,
  ribbonData = {},
  name,
  images,
}) {
  const swiperRef = useRef(null);
  const handleClickZoom = () => {
    onClick(true);
  };

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(0);
    }
  }, [images]);

  return (
    <div
      className="h-auto relative"
      onMouseEnter={() => swiperRef.current?.autoplay.start()}
      onMouseLeave={() => swiperRef.current?.autoplay.stop()}
    >
      <Swiper
        ref={swiperRef}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        modules={[Autoplay, Pagination]}
        slidesPerView={1}
        speed={1000}
        pagination={{ clickable: true }}
        className="product-details"
      >
        {Array.isArray(images) &&
          images?.length > 0 &&
          images
            .filter((image) => image.details_page_display)
            .map((item) => (
              <SwiperSlide key={item.image}>
                <div
                  role="presentation"
                  className="h-auto max-h-[611px] relative cursor-pointer"
                  onClick={handleClickZoom}
                >
                  <ImageComponentV2
                    src={item.image ? getImageUrl(item.image) : null}
                    alt={name}
                    className="w-full h-full max-w-full object-fill xs:object-contain"
                    height={730}
                    width={610}
                    type={imageTypes.tall}
                    loading="lazy"
                  />
                </div>
              </SwiperSlide>
            ))}

        {/* fallback image */}
        {Array.isArray(images) && images?.length === 0 && (
          <div
            role="presentation"
            className="h-[434px] xs:h-[550px] sm:h-[611px] relative cursor-pointer"
            onClick={handleClickZoom}
          >
            <ImageComponentV2
              src={null}
              alt={name}
              className="w-full h-full max-w-full object-fill xs:object-contain"
              height={730}
              width={610}
              type={imageTypes.tall}
              loading="lazy"
            />
          </div>
        )}
      </Swiper>

      {ribbonList.includes(ribbonData.icon) ? (
        <div className="absolute top-2 lg:top-3 left-0 z-[190]">
          <Badge
            type={ribbonData.icon}
            size="sm"
            className=""
            title={ribbonData?.title?.en}
            imageSrc={ribbonData?.placeholder || ''}
          />
        </div>
      ) : null}

      <WishListButton productData={currentProduct} />
    </div>
  );
}

export default ProductDetailsSliderV2;
